import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { ScrollToTop } from "@/lib/seo";

import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import Traiteur from "@/pages/Traiteur";
import Mariages from "@/pages/Mariages";
import CateringProduction from "@/pages/CateringProduction";
import CheffeADomicile from "@/pages/CheffeADomicile";
import Coordination from "@/pages/Coordination";
import Realisations from "@/pages/Realisations";
import Devis from "@/pages/Devis";
import DevisCheffe from "@/pages/DevisCheffe";
import Menus from "@/pages/Menus";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import APropos from "@/pages/APropos";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout, { RequireAuth } from "@/pages/admin/AdminLayout";
import AdminDemandes from "@/pages/admin/AdminDemandes";
import AdminContenu from "@/pages/admin/AdminContenu";
import AdminMedias from "@/pages/admin/AdminMedias";
import AdminImages from "@/pages/admin/AdminImages";
import AdminTransfert from "@/pages/admin/AdminTransfert";
import AdminLegal from "@/pages/admin/AdminLegal";
import AdminMenus from "@/pages/admin/AdminMenus";
import AdminTemoignages from "@/pages/admin/AdminTemoignages";
import AdminReferences from "@/pages/admin/AdminReferences";
import AdminBlog from "@/pages/admin/AdminBlog";

const DevisKeyed = () => {
  const { search } = useLocation();
  if (new URLSearchParams(search).get("service") === "Cheffe à domicile") return <Navigate to="/devis/cheffe-a-domicile" replace />;
  return <Devis key={search} />;
};

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/traiteur" element={<Traiteur />} />
              <Route path="/mariages" element={<Mariages />} />
              <Route path="/catering-production" element={<CateringProduction />} />
              <Route path="/cheffe-a-domicile" element={<CheffeADomicile />} />
              <Route path="/coordination" element={<Coordination />} />
              <Route path="/realisations" element={<Realisations />} />
              <Route path="/menus" element={<Menus />} />
              <Route path="/devis" element={<DevisKeyed />} />
              <Route path="/devis/cheffe-a-domicile" element={<DevisCheffe />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/a-propos" element={<APropos />} />
              <Route path="/mentions-legales" element={<Legal page="mentions" />} />
              <Route path="/confidentialite" element={<Legal page="confidentialite" />} />
              <Route path="/cgv-traiteur" element={<Legal page="cgv-traiteur" />} />
              <Route path="/cgv-coordination" element={<Legal page="cgv-coordination" />} />
              <Route path="/cgv-cheffe" element={<Legal page="cgv-cheffe" />} />
            </Route>

            <Route path="/admin">
              <Route index element={<AdminLogin />} />
              <Route element={<RequireAuth><AdminLayout /></RequireAuth>}>
                <Route path="demandes" element={<AdminDemandes />} />
                <Route path="contenu" element={<AdminContenu />} />
                <Route path="medias" element={<AdminMedias />} />
                <Route path="images" element={<AdminImages />} />
                <Route path="transfert" element={<AdminTransfert />} />
                <Route path="documents-legaux" element={<AdminLegal />} />
                <Route path="menus" element={<AdminMenus />} />
                <Route path="temoignages" element={<AdminTemoignages />} />
                <Route path="references" element={<AdminReferences />} />
                <Route path="blog" element={<AdminBlog />} />
              </Route>
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </ContentProvider>
    </AuthProvider>
  );
}

export default App;
